
import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import { BFormCheckbox } from 'bootstrap-vue'

@Component
export default class RowToggle extends ViewModel {
  @Ref() public readonly checkboxRef!: BFormCheckbox

  @Prop()
  public value!: any

  @Prop({ required: true })
  public toggleValue!: string

  @Prop({ default: false })
  public disabled!: boolean

  @Prop()
  public label!: string

  @Prop()
  public contentCols!: any

  @Prop()
  public labelCols!: any

  @Prop()
  public ifThisWasOn!: any

  public get local_value() {
    return this.value
  }

  public set local_value(value: any) {
    this.$emit('input', value)
  }

  @Watch('local_value')
  public onValueChange(value: any, oldValue: any) {
    if (this.ifThisWasOn) {
      let removed = !value.includes(this.ifThisWasOn) && oldValue.includes(this.ifThisWasOn)
      if (removed) {
        let index = value.indexOf(this.toggleValue)
        let v = value
        if (index > -1) {
          v.splice(index, 1)
          this.$emit('input', v)
        }
      }
    }

    //
    // checl if this.toggleValue exists in value
    if (value.includes(this.toggleValue)) {
      this.$emit('toggle-on', this.toggleValue)
    } else {
      this.$emit('toggle-off', this.toggleValue)
    }
  }
}
